import { combineReducers } from 'redux'
import {
  reducer as globalReducer,
  reducerKey as globalReducerKey,
} from './global-reducer'

const reducerKey = 'learningHub'

const reducer = combineReducers({
  [globalReducerKey]: globalReducer,
})

export { reducer, reducerKey }
